import React, { useState, useContext, useEffect, useReducer } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Card, Row, Col } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import moduleConfig from "./moduleConfig";
import { Store as toast } from "react-notifications-component";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import axios from "../../../config/axios";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import { isEmpty } from "../../../helpers/CommonHelper";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import CMSRichTextEditor from "../../UI/forms/CMSRichTextEditor";
import CMSFormInput from "../../UI/forms/CMSFormInput";
import CMSFormTextArea from "../../UI/forms/CMSFormTextArea";
import CMSFormSelect from "../../UI/forms/CMSFormSelect";
import CMSFormImageWithCrop from "../../UI/forms/CMSFormImageWithCrop";
import {
  updateInitialState,
  updateReducer,
} from "../../../reducers/module/updateReducer";
import {
  loadItemGeneral,
  onSubmitGeneral,
} from "../../../helpers/ModuleHelperFunctions";
import CMSFormTime from "../../UI/forms/CMSFormTime";
import CMSFormDate from "../../UI/forms/CMSFormDate";

const SpecialMealDiscountUpdate = () => {
  const [updateState, updateDispatch] = useReducer(
    updateReducer,
    updateInitialState
  );
  const [formInitialValues, setFormInitialValues] = useState({});
  const { setBreadcrumb } = useContext(BreadcrumbContext);

  let { id } = useParams();
  let navigate = useNavigate();

  const loadItem = async () => {
    await loadItemGeneral(id, `${moduleConfig.url}/${id}`, updateDispatch);
  };

  useEffect(() => {
    //console.log("useEffect called for [id]")
    loadItem();

    setBreadcrumb([
      moduleConfig.breadcrumbs.listing,
      // moduleConfig.breadcrumbs.details,
      moduleConfig.breadcrumbs.update,
    ]);
  }, [id]);
  useEffect(() => {
    if (updateState.data.item && updateState.data.item._id) {
      //if (moduleConfig.fields && moduleConfig.fields.length > 0) {

      // let formFieldsWithFetchData = {}
      // moduleConfig.fields.map((field, index) => {

      //     formFieldsWithFetchData[field.fieldName] = updateState.data.item[field.fieldName]
      // })
      // console.log("Here =>>>>>>>>>>>>>>", formFieldsWithFetchData)
      setFormInitialValues(updateState.data.item);

      //};
    }
  }, [updateState.data]);

  return (
    <DashboardLayout>
      {updateState.status === "fetching" && updateState.isLoading && (
        <ContainerLoading />
      )}
      {updateState.error && updateState.status === "fetchFailed" ? (
        <BlockErrorMessage error={updateState.error} />
      ) : (
        <>
          <ModuleHeader
            moduleTitle={`Update ${moduleConfig.singleItemTitle}`}
            moduleUrl={moduleConfig.url}
          ></ModuleHeader>

          {Object.keys(formInitialValues).length > 0 &&
            updateState.data &&
            updateState.data.item &&
            !isEmpty(updateState.data.item._id) && (
              <section className="content">
                <Card>
                  <Card.Body>
                    {updateState.isLoading && (
                      <div className="overlay position-absolute containerLoading">
                        <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                      </div>
                    )}
                    {/* {console.log(formInitialValues)} */}
                    <Formik
                      initialValues={{
                        ...formInitialValues,
                        //file:updateState.data.item.image,
                      }}
                      validationSchema={yup.object({
                        title: yup.string().required("Title is required"),

                        planId: yup.string().required("Plan is required"),

                        requiredKidsCount: yup
                          .number()
                          .typeError("Required kids count must be a number")
                          .required("Required kids count is required"),

                        discountValue: yup
                          .number()
                          .typeError("Discount value must be a number")
                          .required("Discount value is required"),

                        description: yup.string().nullable(),

                        status: yup.string().required("Status is required"),
                      })}
                      enableReinitialize={true}
                      validateOnChange={true}
                      validateOnBlur={true}
                      onSubmit={async (values, { resetForm }) => {
                        await onSubmitGeneral(
                          values,
                          `${moduleConfig.url}/${id}`,
                          moduleConfig.url,
                          updateDispatch,
                          navigate
                        );
                      }}
                    >
                      {(form) => (
                        <Form onSubmit={form.handleSubmit}>
                          {updateState.error && (
                            <FormErrorMessage error={updateState.error} />
                          )}

                          <CMSFormInput
                            name="title"
                            label="Title"
                            required={true}
                            form={form}
                          />

                          <CMSFormSelect
                            name="planId"
                            label="Plan"
                            selectionValue="value"
                            selected={form.values.planId}
                            required={true}
                            form={form}
                            options={
                              updateState.data && updateState.data.items
                                ? updateState.data.items
                                : []
                            }
                            displayValue="label"
                          />

                          <CMSFormInput
                            name="requiredKidsCount"
                            label="Required Kids Count"
                            info={'Discount applies if the user meets the active subscription count and adds a new subscription'}
                            required={true}
                            form={form}
                          />

                          <CMSFormInput
                            name="discountValue"
                            label="Discount Value"
                            info={'Discount will be applied in percentage'}
                            required={true}
                            form={form}
                          />
{/* 
                          <CMSFormTextArea
                            name="description"
                            label="Description"
                            form={form}
                            maxLength={300}
                          /> */}

                          <CMSFormSelect
                            name="status"
                            label="Status"
                             required={true}
                            form={form}
                            options={[
                              { label: "Select Status...", value: "" },
                              { label: "Enabled", value: "1" },
                              { label: "Disabled", value: "0" },
                            ]}
                          />

                          <button className="btn btn-primary" type="submit">
                            Submit
                          </button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </section>
            )}
        </>
      )}
    </DashboardLayout>
  );
};
export default SpecialMealDiscountUpdate;
